var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.presses),function(press){return _c('li',{key:press.title},[_c('PressItem',{attrs:{"press":press}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }